document.addEventListener( 'DOMContentLoaded', function () {
	const form = document.getElementById( 'newsletter-form' );
	const emailInput = document.getElementById( 'newsletter-email' );
	const submitButton = document.getElementById( 'newsletter-submit' );
	const messageDiv = document.getElementById( 'newsletter-message' );

	if ( form ) {
		form.addEventListener( 'submit', function ( e ) {
			e.preventDefault();

			const email = emailInput.value.trim();

			if ( ! email ) {
				showMessage( 'Please enter your email address.', 'error' );
				return;
			}

			if ( ! isValidEmail( email ) ) {
				showMessage( 'Please enter a valid email address.', 'error' );
				return;
			}

			// Disable form during submission
			submitButton.disabled = true;
			submitButton.textContent = 'Subscribing...';

			// Prepare form data
			const formData = new FormData();
			formData.append( 'action', 'mailchimp_subscribe' );
			formData.append( 'email', email );

			// Send AJAX request
			fetch( managewp_script_data.ajax_url, {
				method: 'POST',
				body: formData,
			} )
				.then( ( response ) => response.json() )
				.then( ( data ) => {
					if ( data.success ) {
						showMessage( data.data.message, 'success' );
						emailInput.value = '';
					} else {
						showMessage( data.data.message, 'error' );
					}
				} )
				.catch( ( error ) => {
					console.error( 'Error:', error );
					showMessage(
						'An error occurred. Please try again.',
						'error'
					);
				} )
				.finally( () => {
					// Re-enable form
					submitButton.disabled = false;
					submitButton.textContent = 'Subscribe';
				} );
		} );
	}

	function showMessage( message, type ) {
		messageDiv.className =
			type === 'success' ? '!text-green-light' : '!text-pink-light';
		messageDiv.textContent = message;
		messageDiv.classList.remove( 'hidden' );

		// Add class to form
		form.classList.add(
			type === 'success' ? '!ring-green-light' : '!ring-pink-light'
		);

		// Hide message after 5 seconds
		setTimeout( () => {
			messageDiv.classList.add( 'hidden' );
			form.classList.remove(
				type === 'success' ? '!ring-green-light' : '!ring-pink-light'
			);
		}, 5000 );
	}

	function isValidEmail( email ) {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test( email );
	}
} );
